import { useMemo } from "react";
import { transformToFloat } from "../../../../lib/transformToFloat";
import {
  MAX_AUTO_GENERATED_NUMBER_MSG,
  NUMBER_INPUT_REQUIRED,
} from "../../../../lib/constants";
import { Rule } from "antd/es/form";

export const useRules = () => {
  const MAX_VALUE_RULE = 999999999;

  const rules: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          const val: number | null = transformToFloat(value);
          if (!val) {
            return Promise.reject(new Error(NUMBER_INPUT_REQUIRED));
          }

          if (val <= MAX_VALUE_RULE) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(MAX_AUTO_GENERATED_NUMBER_MSG));
        },
      }),
    ];
  }, []);

  return { rules };
};
